var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.utils.string.vNotEmpty(_vm.url))?_c('cloud-imgs',{ref:"clouds",attrs:{"border-radius":_vm.borderRadius,"click-view":_vm.clickView,"img-width":_vm.imgWidth,"img-height":_vm.imgHeight,"show-del-btn":_vm.showDelBtn,"imgs":[{ url: _vm.url }]},on:{"item-delete":function($event){return _vm.$emit('item-delete')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }